export interface IBingoScore {
  playerId: string;
  playerName: string;
  bingoCount: number;
  fullBingoCount: number;
  completedTasksNum: number;
  updateTime: string | number | undefined;
}

export class BingoScoreClass implements IBingoScore {
  playerId: string;
  playerName: string;
  bingoCount: number;
  fullBingoCount: number;
  completedTasksNum: number;
  updateTime: string | number | undefined;

  constructor(bingo?: Partial<IBingoScore>) {
    this.playerId = bingo?.playerId ?? '';
    this.playerName = bingo?.playerName ?? '';
    this.bingoCount = bingo?.bingoCount ?? 0;
    this.fullBingoCount = bingo?.fullBingoCount ?? 0;
    this.completedTasksNum = bingo?.completedTasksNum ?? 0;
    this.updateTime = bingo?.updateTime ?? '';
  }
}
